import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-copyright',
  templateUrl: './copyright.component.html',
  styleUrls: ['./copyright.component.scss']
})
export class CopyrightComponent implements OnInit {

  today: number = Date.now();
  currentYear: number;

  constructor() { }

  ngOnInit() {
    this.currentYear = (new Date()).getFullYear();
  }

}
